import styles from '@/styles/components/ButtonTapHighlight.module.scss'
import { ButtonHTMLAttributes, FC, PropsWithChildren, ReactNode } from 'react'
import { classNames } from '@tmap-web-lib/utils'

export interface ButtonTapHighlightProps extends PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> {
  className?: string;
  children: ReactNode;
}

export const ButtonTapHighlight: FC<ButtonTapHighlightProps> = ({
    type = 'button',
    className,
    children,
    ...attrs
  })  => {

  return (
    <button
      type={type}
      className={classNames(
        styles.button,
        className,
      )}
      { ...attrs }
    >
      {children}
    </button>
  )
}
